export const Button = {
  baseStyle: {
    boxShadow: 'none',
    fontWeight: 'normal',
    borderRadius: 'base',
  },
  // sizes: sm, md, lg
  sizes: {
    sm: {
      fontSize: 'xs',
      px: '12px',
      py: '6px',
    },
    md: {
      fontSize: 'lg',
      px: '16px',
      py: '8px',
    },
    lg: {
      fontSize: 'lg',
      px: '24px',
      py: '10px',
    },
  },
  // Two variants: outline and primary
  variants: {
    outline: {
      border: '1px solid',
      borderColor: 'brand.borderColor',
      bg: 'brand.white',
      color: 'brand.primary',
      _disabled: {
        opacity: 0.5,
      },
      _hover: {
        bg: 'button.outlineHover',
      },
      _focus: {
        bg: 'brand.white',
        boxShadow: 'none',
        border: '2px solid',
        borderColor: 'black',
      },
    },
    outlineContrast: {
      border: '1px solid',
      borderColor: 'brand.borderColor',
      bg: 'brand.white',
      color: 'brand.contrast',
      _disabled: {
        opacity: 0.5,
      },
      _hover: {
        bg: 'button.outlineHover',
      },
      _focus: {
        bg: 'brand.white',
        boxShadow: 'none',
        border: '2px solid',
        borderColor: 'black',
      },
    },
    dotted: {
      border: '1px dashed',
      borderColor: 'brand.borderColor',
      bg: 'brand.white',
      color: 'brand.primary',
      _disabled: {
        opacity: 0.5,
      },
      _hover: {
        bg: 'button.outlineHover',
      },
      _focus: {
        bg: 'button.outlineFocus',
        boxShadow: 'none',
        border: '2px solid',
        borderColor: 'black',
      },
    },
    primary: {
      border: '1px solid',
      borderColor: 'button.primary',
      bg: 'button.primary',
      color: 'brand.white',
      _disabled: {
        opacity: 0.5,
        bg: 'button.primary',
      },
      _hover: {
        bg: 'button.primaryHover',
        _disabled: {
          bg: 'button.primaryHover',
        },
      },
      _focus: {
        bg: 'button.primaryFocus',
        boxShadow: 'none',
        border: '2px solid',
        borderColor: 'black',
      },
    },
  },
  // The default size and variant values
  defaultProps: {
    size: 'lg',
    variant: 'primary',
  },
}
